import type { access as en } from "../en/access";
import type { Messages } from "../types";

/** التسجيل = طلب وصول (ALP-85). */
export const access: Messages<typeof en> = {
  title: "اطلب الوصول إلى منصة ملفك",
  hint: "أخبرنا عنك وعن نشاطك. يراجع فريقنا كل طلب ويتواصل معك، عادةً خلال يوم عمل واحد.",
  steps: { you: "أنت", contact: "التواصل", business: "نشاطك" },
  fields: {
    email: "البريد الإلكتروني للعمل",
    username: "اسم المستخدم",
    usernameHint: "من 3 إلى 30 حرفًا: أحرف إنجليزية وأرقام ونقطة وشرطة أو شرطة سفلية. يصبح معرّفك في منصة ملفك.",
    password: "كلمة المرور",
    passwordHint: "10 أحرف على الأقل. امزج بين الأحرف والأرقام والرموز.",
    phone: "رقم الهاتف",
    phoneHint: "نتصل بك أو نراسلك بخصوص طلبك.",
    country: "رمز الدولة",
    company: "الشركة أو العلامة التجارية",
    optional: "اختياري",
    reason: "لماذا تريد استخدام ملفك؟",
    reasonHint: "بضعة أسطر عن حسابك وأهدافك (20 حرفًا على الأقل).",
    reasonPlaceholder: "مثلًا: نبيع عبر إنستغرام وتصلنا أسئلة كثيرة عن الأسعار في التعليقات والرسائل…",
    heardFrom: "كيف سمعت عنا؟",
    heardFromNone: "اختر",
    consentBefore: "أوافق على",
    consentAnd: "و",
    terms: "الشروط",
    privacy: "سياسة الخصوصية",
    honeypot: "اترك هذا الحقل فارغًا",
  },
  heard: { instagram: "إنستغرام", search: "محرك بحث", friend: "صديق أو زميل", event: "فعالية", partner: "شريك أو وكالة", other: "غير ذلك" },
  strength: { label: "قوة كلمة المرور: {{level}}", s0: "قصيرة جدًا", s1: "ضعيفة", s2: "مقبولة", s3: "جيدة", s4: "قوية" },
  username: { checking: "جارٍ التحقق…", available: "متاح", taken: "اسم المستخدم هذا مستخدم", reserved: "اسم المستخدم هذا محجوز", invalid: "استخدم من 3 إلى 30 حرفًا إنجليزيًا أو رقمًا أو نقطة أو شرطة" },
  errors: {
    required: "مطلوب",
    invalid_email: "أدخل بريدًا إلكترونيًا صحيحًا",
    too_short: "قصير جدًا",
    too_long: "طويل جدًا",
    invalid_chars: "استخدم أحرفًا إنجليزية وأرقامًا ونقطة أو شرطة (ليس في البداية أو النهاية)",
    reserved: "اسم المستخدم هذا محجوز",
    taken: "اسم المستخدم هذا مستخدم",
    too_weak: "اختر كلمة مرور أقوى",
    invalid_phone: "أدخل رقمًا صحيحًا للدولة المختارة",
    reason_short: "أخبرنا أكثر قليلًا (20 حرفًا على الأقل)",
    consent_required: "يرجى الموافقة على الشروط وسياسة الخصوصية",
    captcha_failed: "فشل التحقق الأمني. حاول مرة أخرى.",
    rateLimited: "طلبات كثيرة من هذه الشبكة. حاول لاحقًا.",
    generic: "حدث خطأ. حاول مرة أخرى.",
  },
  submit: "أرسل الطلب",
  submitting: "جارٍ الإرسال…",
  haveAccount: "تمت الموافقة على طلبك؟",
  goLogin: "سجّل الدخول",
  reasonCount_zero: "{{count}} / 2000",
  reasonCount_one: "{{count}} / 2000",
  reasonCount_two: "{{count}} / 2000",
  reasonCount_few: "{{count}} / 2000",
  reasonCount_many: "{{count}} / 2000",
  reasonCount_other: "{{count}} / 2000",
  received: {
    title: "شكرًا لك، سنتواصل معك",
    text: "وصل طلبك إلى فريقنا. نراجع كل طلب بأنفسنا ونعود إليك بالهاتف أو البريد، عادةً خلال يوم عمل واحد.",
    next: "ماذا بعد؟",
    step1: "نقرأ طلبك وقد نتصل بك لبعض الأسئلة.",
    step2: "بعد الموافقة، سجّل الدخول بالبريد وكلمة المرور اللذين اخترتهما.",
    step3: "اربط حساب إنستغرام وابدأ خلال دقائق.",
    back: "العودة إلى الصفحة الرئيسية",
    login: "الذهاب إلى تسجيل الدخول",
  },
  login: {
    pendingTitle: "طلبك قيد المراجعة",
    pending: "سنتواصل معك قريبًا. يمكنك تسجيل الدخول فور الموافقة على طلبك.",
    rejectedTitle: "لم تتم الموافقة على طلبك",
    rejected: "لم نتمكن من الموافقة على هذا الطلب. إن كنت ترى أنه خطأ، اطلب الوصول مرة أخرى مع تفاصيل أكثر.",
    noAccount: "ليس لديك حساب بعد؟",
    request: "اطلب الوصول",
  },
};
